import { Contract } from "../../../../models/Entities/Contracts/Contract";
import { ContractBranch } from "../../../../models/Entities/Contracts/ContractBranch";
import { ContractStage } from "../../../../models/Entities/Contracts/ContractStage";
import { StageCycle } from "../../../../models/Entities/Contracts/StageCycle";
import { ErrorType } from "../../../../models/HttpError";

// stores
import * as ContractStageStore from '../../../../redux/middleware/ContractStageMiddleware';
import * as ContracStore from '../../../../redux/middleware/ContractMiddleware';
import * as ContractBranchStore from '../../../../redux/middleware/ContractBranchsMiddleware';

// common functions
import * as Functions from '../../../../functions/common'

//State
import { AppState } from "../../../../redux/reducers";
import { ContractAddendum } from "../../../../models/Entities/Contracts/ContractAddendum";



interface IProps {
    ContractId: number;
    ContractAddendumId: number;
}
  
  interface ConnectedProps {
    isLoading: boolean;
    isLoadingSuccessfully: boolean;
    isDeleting: boolean;
    isDeletedSuccessfully: boolean;
    failOnLoading: boolean;
    failOnDeleting: boolean;
    error: ErrorType | undefined;
    Contract: Contract | undefined;
    Stages: ContractStage[];
    Branches: ContractBranch[];
    AreBranchesLoaded: boolean;
    Cycles: StageCycle[];
  }
  
  interface DispatchProps {
    GetAllContractsStage: typeof ContractStageStore.actionCreators.GetAllContractsStage;
    GetAllContractStagesByAddendumId: typeof ContractStageStore.actionCreators.GetAllContractStagesByAddendumId;
    GetContractStageById: typeof ContractStageStore.actionCreators.GetContractStageById;
    GetContractById: typeof ContracStore.actionCreators.GetContractById;
    DeleteContractStage: typeof ContractStageStore.actionCreators.DeleteContractStage;
    UpdateContractStage: typeof ContractStageStore.actionCreators.UpdateContractStage;
    DetachContractStageBranch: typeof ContractStageStore.actionCreators.DetachContractStageBranch;
    GetContractBranchsByAddendumId: typeof ContractBranchStore.actionCreators.GetContractBranchsByAddendumId;
  }
  
  export type Props = IProps & ConnectedProps & DispatchProps;
  
  export const mapStateToProps = (state: AppState, ownProps: IProps) => {

    const CurrentAddendum = state.Contract?.list?.find((item: Contract) => item.id === ownProps.ContractId )?.addendums?.find((item: ContractAddendum) => item.id === ownProps.ContractAddendumId);

    return {
      isLoading: CurrentAddendum?.isGettingContractStages,
      isLoadingSuccessfully: (!!CurrentAddendum && !CurrentAddendum?.isGettingContractStages && !CurrentAddendum?.FailGettingContractStages) || false,
      failOnLoading: (CurrentAddendum?.FailGettingContractStages || false),
      AddRangeFinalized: false,
      isDeleting: false,
      isDeletedSuccessfully: false,
      failOnDeleting: false,
      error: CurrentAddendum?.ErrorGettingContractStages || undefined,
      Contract: ownProps.ContractId && state.Contract && state.Contract?.list ? state.Contract?.list?.find((item: Contract) => item.id === ownProps.ContractId ) : undefined,
      Stages: CurrentAddendum?.stages?.sort(Functions.DynamicSortNumeric('stageOrder')) || [],
      Branches: CurrentAddendum?.branches || [],
      // only once the addendum branches were actually fetched can a dangling branchId be told
      // apart from "branches not loaded yet"
      AreBranchesLoaded: CurrentAddendum?.isGettingContractBranchesSuccess === true || (CurrentAddendum?.branches?.length || 0) > 0,
      Cycles: ownProps.ContractId && state.Contract && state.Contract?.list ? state.Contract?.list?.find((item: Contract) => item.id === ownProps.ContractId )?.cycles: []
    }
  };
  
  export const mapDispatchToProps = {
    ...ContractStageStore.actionCreators,
    ...ContracStore.actionCreators,
    GetContractBranchsByAddendumId: ContractBranchStore.actionCreators.GetContractBranchsByAddendumId
  };